import _styled from "@emotion/styled-base";
import { Link } from 'gatsby';
export var Header = _styled("header", {
  target: "eqssncc0"
})("position:fixed;top:0;left:0;width:100%;padding:24px;display:flex;align-items:center;justify-content:space-between;background-color:white;border-bottom:1px solid #f4f4f4;transition:background-color 0.3s ease;z-index:5;@media (min-width:768px){background-color:", function (_ref) {
  var isScrolling = _ref.isScrolling;
  return isScrolling ? 'white' : 'transparent';
}, ";border-bottom:", function (_ref2) {
  var isScrolling = _ref2.isScrolling;
  return isScrolling ? '1px solid #f4f4f4' : 'none';
}, ";}");
export var Nav = _styled("nav", {
  target: "eqssncc1"
})({
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
});
export var HomeLink =
/*#__PURE__*/
_styled(Link, {
  target: "eqssncc2"
})({
  name: "u1jr60",
  styles: "height:40px;"
});
export var Logo = _styled("img", {
  target: "eqssncc3"
})({
  name: "q3o4ra",
  styles: "height:40px;margin:0;"
});
export var NavLink =
/*#__PURE__*/
_styled(Link, {
  target: "eqssncc4"
})({
  name: "ygbrz2",
  styles: "text-decoration:none;appearance:none;font-weight:500;font-size:14px;color:black;padding:0 12px;letter-spacing:0.5px;"
});